import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=addcce56&scoped=true&"
import script from "./NotificationsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NotificationsList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=addcce56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addcce56",
  null
  
)

export default component.exports